import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MetaDataService } from '../../../services/meta/meta-data.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.css'],
  imports: [RouterLink, TranslateModule]
})
export class NotFoundPageComponent implements OnInit {
  private readonly metaDataService = inject(MetaDataService);

  ngOnInit(): void {
    this.metaDataService.applyRouteMeta('/404');
  }
}

